module.exports = __webpack_public_path__ + "static/assets/5cfbf7dc7a981276289e7d911cb142c3.png";